import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CustomLoader from "./loader";
import { addMobiguestlinkLogs } from "../services/logs";

const RedirectScan = () => {
  //   const { phone, businessid, text } = useParams();
  let phone;
  let businessid;
  let text;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    phone = queryParams.get("phone");
    businessid = queryParams.get("businessid");
    text = queryParams.get("text");

    text = encodeURIComponent(text);

    const fullUrl = window.location.href;
    const urlPayload = {
      url: fullUrl,
      businessid: businessid || "",
      type: "redirectscan"
    }

    addMobiguestlinkLogs(urlPayload)

    if (
      navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/
      )
    ) {
      const whatsappURL = `whatsapp://send?phone=${phone}&text=${text}`;
      const fallbackURL = `https://mobiguest-ai.web.app/gem?businessid=${businessid}`; /* ?businessid=${businessid} */


      let fallbackTimeout;

      window.location.href = whatsappURL;

      fallbackTimeout = setTimeout(() => {
        window.location.href = fallbackURL;
      }, 2000);

      const handleBlur = () => clearTimeout(fallbackTimeout);

      window.addEventListener("blur", handleBlur);

      return () => {
        window.removeEventListener("blur", handleBlur);
      };
    } else {
      const whatsappURL = `https://wa.me/?${phone}&text=${text}`;
      window.location.href = whatsappURL;
    }
  }, [navigate]);

  return (
    <div style={{ width: "100%", alignItems: "center" }}>
      <CustomLoader />
    </div>
  );
};

export default RedirectScan;
